import {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  BrowserRouter,
} from "react-router-dom";

import {
  CssBaseline,
  ThemeProvider,
} from "@mui/material";

import AOS from "aos";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "aos/dist/aos.css";
import "./assets/css/materialdesignicons.min.css";
import "./assets/scss/style.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { getTheme } from "./theme";
import AllRoutes from "./routes/Routes";

export default function App() {
  const [darkMode, setDarkMode] =
    useState<boolean>(() => {
      return (
        localStorage.getItem(
          "theme"
        ) === "dark"
      );
    });

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    const syncTheme = () => {
      setDarkMode(
        localStorage.getItem(
          "theme"
        ) === "dark"
      );
    };

    window.addEventListener(
      "storage",
      syncTheme
    );

    const interval =
      window.setInterval(
        syncTheme,
        300
      );

    return () => {
      window.removeEventListener(
        "storage",
        syncTheme
      );

      window.clearInterval(
        interval
      );
    };
  }, []);

  const theme = useMemo(
    () => getTheme(darkMode),
    [darkMode]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <BrowserRouter>
        <AllRoutes />
      </BrowserRouter>
    </ThemeProvider>
  );
}